export const heroSlides = [
  {
    id: 1,
    title: '探索精彩韩漫世界',
    subtitle: '海量韩国漫画免费在线阅读',
    description: '无需注册，随时随地享受流畅的下拉式阅读体验，发现你喜爱的韩漫作品',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20illustration%20of%20Korean%20manhwa%20comic%20panels%20floating%20in%20a%20warm%20atmospheric%20space%2C%20with%20rich%20colors%20of%20coral%20red%20and%20golden%20amber%2C%20cinematic%20lighting%2C%20abstract%20comic%20page%20textures%2C%20elegant%20and%20modern%20aesthetic%2C%20high%20contrast%2C%20artistic%20composition&width=1600&height=900&seq=hero-slide-01&orientation=landscape',
    ctaText: '开始阅读',
    ctaLink: '#hot-comics',
  },
  {
    id: 2,
    title: '最新热门连载',
    subtitle: '每日更新，精彩不断',
    description: '追踪最新上线的韩漫作品，第一时间阅读热门连载漫画',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20and%20dynamic%20artistic%20illustration%20of%20Korean%20webtoon%20style%20characters%20in%20action%20poses%2C%20warm%20golden%20and%20coral%20tones%2C%20dramatic%20composition%20with%20motion%20lines%20and%20speed%20effects%2C%20modern%20digital%20art%20style%2C%20rich%20textures%2C%20cinematic%20lighting&width=1600&height=900&seq=hero-slide-02&orientation=landscape',
    ctaText: '查看热门',
    ctaLink: '#hot-comics',
  },
  {
    id: 3,
    title: '分类发现好作品',
    subtitle: '多种题材，应有尽有',
    description: '从浪漫爱情到悬疑惊悚，按分类找到最适合你口味的韩漫',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20illustration%20showing%20various%20Korean%20manhwa%20genres%20in%20a%20colorful%20mosaic%20arrangement%2C%20romance%20fantasy%20action%20drama%20thriller%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20soft%20artistic%20textures%2C%20elegant%20layout%2C%20modern%20digital%20art&width=1600&height=900&seq=hero-slide-03&orientation=landscape',
    ctaText: '探索分类',
    ctaLink: '#categories',
  },
];

export const hotComics = [
  {
    id: 1,
    slug: 'secret-class',
    title: '秘密教学',
    author: '作家A',
    rating: 4.8,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20and%20woman%20in%20a%20romantic%20moment%2C%20warm%20soft%20lighting%2C%20elegant%20character%20design%2C%20clean%20simple%20background%2C%20webtoon%20cover%20art%20style&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    description: '一段隐秘而动人的师生关系故事，画风精美细腻',
    tags: ['恋爱', '校园', '剧情'],
    views: 1280000,
  },
  {
    id: 2,
    slug: 'solo-leveling',
    title: '我独自升级',
    author: '作家B',
    rating: 4.9,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20aura%20and%20glowing%20eyes%2C%20action%20pose%2C%20dramatic%20lighting%2C%20clean%20simple%20background%2C%20webtoon%20cover%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    description: '从最弱猎人到最强存在，逆袭成长的热血传奇',
    tags: ['奇幻', '动作', '冒险'],
    views: 3560000,
  },
  {
    id: 3,
    slug: 'true-beauty',
    title: '女神降临',
    author: '作家C',
    rating: 4.7,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20makeup%2C%20glamorous%20transformation%20theme%2C%20soft%20warm%20lighting%2C%20clean%20simple%20background%2C%20webtoon%20cover%20art%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '恋爱',
    description: '通过化妆变身的少女，在美貌与真实之间寻找自我',
    tags: ['恋爱', '校园', '成长'],
    views: 2890000,
  },
  {
    id: 4,
    slug: 'tower-of-god',
    title: '神之塔',
    author: '作家D',
    rating: 4.8,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20boy%20climbing%20a%20giant%20tower%2C%20fantasy%20world%2C%20dramatic%20perspective%2C%20clean%20simple%20background%2C%20webtoon%20cover%20art%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '奇幻',
    description: '登上神秘高塔，追寻珍贵之物，史诗级奇幻冒险',
    tags: ['奇幻', '冒险', '友情'],
    views: 4210000,
  },
  {
    id: 5,
    slug: 'lookism',
    title: '外貌至上主义',
    author: '作家E',
    rating: 4.6,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20high%20school%20boy%20with%20stylish%20hair%2C%20school%20uniform%2C%20confident%20expression%2C%20clean%20simple%20background%2C%20webtoon%20cover%20art%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '校园',
    description: '两个身体的秘密，探讨外貌与人生的深刻故事',
    tags: ['校园', '剧情', '社会'],
    views: 1750000,
  },
  {
    id: 6,
    slug: 'doctors-rebirth',
    title: '医者重生',
    author: '作家F',
    rating: 4.5,
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20doctor%20in%20traditional%20Korean%20hanbok%20with%20medical%20tools%2C%20historical%20fantasy%20setting%2C%20warm%20lighting%2C%20clean%20simple%20background%2C%20webtoon%20cover%20art%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '奇幻',
    description: '现代医生穿越到古代，用医术改变命运的奇幻之旅',
    tags: ['奇幻', '历史', '医疗'],
    views: 890000,
  },
];

export const categories = [
  {
    id: 1,
    slug: 'romance',
    name: '恋爱',
    icon: 'ri-heart-line',
    description: '浪漫爱情故事',
    count: 1250,
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20tones%2C%20dreamy%20atmosphere%2C%20clean%20simple%20aesthetic%2C%20webtoon%20art%20style&width=600&height=400&seq=cat-romance&orientation=landscape',
  },
  {
    id: 2,
    slug: 'fantasy',
    name: '奇幻',
    icon: 'ri-magic-line',
    description: '奇幻世界冒险',
    count: 980,
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20magical%20fantasy%20world%20with%20castles%20and%20dragons%2C%20warm%20golden%20and%20amber%20tones%2C%20epic%20scale%2C%20clean%20simple%20aesthetic%2C%20webtoon%20art%20style&width=600&height=400&seq=cat-fantasy&orientation=landscape',
  },
  {
    id: 3,
    slug: 'action',
    name: '动作',
    icon: 'ri-sword-line',
    description: '热血战斗激战',
    count: 860,
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20dynamic%20action%20fight%20scene%20with%20martial%20arts%2C%20dramatic%20motion%20effects%2C%20warm%20coral%20tones%2C%20clean%20simple%20aesthetic%2C%20webtoon%20art%20style&width=600&height=400&seq=cat-action&orientation=landscape',
  },
  {
    id: 4,
    slug: 'campus',
    name: '校园',
    icon: 'ri-building-2-line',
    description: '青春校园生活',
    count: 720,
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20students%20in%20school%20uniform%20at%20a%20beautiful%20campus%2C%20warm%20sunlight%2C%20youthful%20atmosphere%2C%20clean%20simple%20aesthetic%2C%20webtoon%20art%20style&width=600&height=400&seq=cat-campus&orientation=landscape',
  },
  {
    id: 5,
    slug: 'thriller',
    name: '悬疑',
    icon: 'ri-search-eye-line',
    description: '悬疑惊悚推理',
    count: 540,
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20dark%20alley%20with%20shadowy%20figure%2C%20suspenseful%20atmosphere%2C%20warm%20dark%20amber%20tones%2C%20clean%20simple%20aesthetic%2C%20webtoon%20art%20style&width=600&height=400&seq=cat-thriller&orientation=landscape',
  },
  {
    id: 6,
    slug: 'drama',
    name: '剧情',
    icon: 'ri-emotion-line',
    description: '感人剧情故事',
    count: 630,
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20emotional%20dramatic%20scene%20with%20characters%20expressing%20deep%20feelings%2C%20warm%20coral%20lighting%2C%20clean%20simple%20aesthetic%2C%20webtoon%20art%20style&width=600&height=400&seq=cat-drama&orientation=landscape',
  },
];

export const latestArticles = [
  {
    id: 1,
    slug: 'top-10-korean-manhwa-2026',
    title: '2026年必看十大热门韩漫推荐',
    excerpt: '从经典名作到新晋黑马，为你精选本年度最值得一读的韩国漫画作品，每一部都值得细细品味...',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20collage%20of%20top%2010%20comic%20characters%20in%20a%20ranking%20layout%2C%20warm%20golden%20and%20coral%20tones%2C%20elegant%20design%2C%20clean%20aesthetic%2C%20webtoon%20art%20style&width=800&height=450&seq=article-01&orientation=landscape',
    category: '恋爱',
    author: '编辑小韩',
    date: '2026-07-28',
    readTime: '8 分钟',
  },
  {
    id: 2,
    slug: 'korean-webtoon-reading-guide',
    title: '韩漫阅读入门：新手必知的下拉式阅读技巧',
    excerpt: '刚接触韩漫不知从何下手？这篇指南帮你快速掌握下拉式韩漫的阅读方法与平台选择技巧...',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20person%20reading%20webtoon%20on%20a%20phone%20with%20comic%20panels%20floating%20around%2C%20warm%20cozy%20lighting%2C%20clean%20aesthetic%2C%20webtoon%20art%20style&width=800&height=450&seq=article-02&orientation=landscape',
    category: '奇幻',
    author: '漫迷小助手',
    date: '2026-07-25',
    readTime: '6 分钟',
  },
  {
    id: 3,
    slug: 'romance-manhwa-recommendations',
    title: '少女心爆棚！五部让你心动的恋爱韩漫',
    excerpt: '甜蜜的恋爱故事总是让人欲罢不能，这五部恋爱韩漫每一部都充满了心动瞬间...',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20sweet%20romantic%20couple%20moment%20with%20hearts%20and%20flowers%2C%20soft%20pink%20and%20warm%20tones%2C%20clean%20aesthetic%2C%20webtoon%20art%20style&width=800&height=450&seq=article-03&orientation=landscape',
    category: '恋爱',
    author: '编辑小韩',
    date: '2026-07-22',
    readTime: '7 分钟',
  },
  {
    id: 4,
    slug: 'manhwa-vs-manga-comparison',
    title: '韩漫vs日漫：两者到底有什么不同？',
    excerpt: '韩国漫画和日本漫画在画风、叙事方式和阅读体验上有哪些差异？一文带你全面了解...',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20split%20comparison%20of%20Korean%20webtoon%20and%20Japanese%20manga%20styles%20side%20by%20side%2C%20warm%20coral%20and%20amber%20tones%2C%20clean%20aesthetic%2C%20webtoon%20art%20style&width=800&height=450&seq=article-04&orientation=landscape',
    category: '奇幻',
    author: '漫迷小助手',
    date: '2026-07-18',
    readTime: '10 分钟',
  },
  {
    id: 5,
    slug: 'hidden-gems-underrated-manhwa',
    title: '被低估的神作：冷门但超好看的韩漫推荐',
    excerpt: '这些韩漫虽然知名度不高，但质量和剧情绝对不输热门作品，每一部都值得被发现...',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20hidden%20treasure%20chest%20opening%20with%20comic%20characters%20emerging%2C%20warm%20golden%20glow%2C%20clean%20aesthetic%2C%20webtoon%20art%20style&width=800&height=450&seq=article-05&orientation=landscape',
    category: '剧情',
    author: '编辑小韩',
    date: '2026-07-15',
    readTime: '9 分钟',
  },
  {
    id: 6,
    slug: 'fantasy-manhwa-world-building',
    title: '韩漫奇幻世界观的魅力：从神之塔到我独自升级',
    excerpt: '韩国奇幻漫画以其独特的世界观构建吸引了大批读者，探索韩漫奇幻世界的构建艺术...',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20an%20epic%20fantasy%20world%20with%20towers%20and%20magical%20landscapes%2C%20warm%20amber%20and%20golden%20tones%2C%20clean%20aesthetic%2C%20webtoon%20art%20style&width=800&height=450&seq=article-06&orientation=landscape',
    category: '奇幻',
    author: '漫迷小助手',
    date: '2026-07-10',
    readTime: '8 分钟',
  },
];

export const faqs = [
  {
    id: 1,
    question: '韩漫网站上的漫画都是免费的吗？',
    answer: '是的，我们网站上的所有韩国漫画都可以免费在线阅读。无需付费、无需订阅，打开即看。我们致力于为广大韩漫爱好者提供一个完全免费的漫画阅读平台。',
  },
  {
    id: 2,
    question: '需要注册账号才能看漫画吗？',
    answer: '不需要！我们的韩漫网站无需注册即可直接阅读所有漫画内容。随时随地打开网站就能畅享下拉式韩漫阅读体验，没有任何门槛。',
  },
  {
    id: 3,
    question: '什么是下拉式韩漫？怎么阅读？',
    answer: '下拉式韩漫（Webtoon）是韩国漫画特有的一种格式，专为手机和电脑屏幕优化。您只需向下滚动页面，漫画内容就会流畅地连续展示，无需翻页，阅读体验非常丝滑。',
  },
  {
    id: 4,
    question: '网站上的漫画多久更新一次？',
    answer: '我们会紧跟各大韩漫平台的更新节奏，热门连载作品通常会在原作更新后尽快同步。您可以收藏喜欢的作品，随时回来查看最新章节。',
  },
  {
    id: 5,
    question: '网站支持手机上阅读吗？',
    answer: '当然支持！我们的网站针对手机端进行了全面优化，在手机上也能享受流畅的下拉式阅读体验。无论您使用手机、平板还是电脑，都能获得最佳的漫画阅读感受。',
  },
  {
    id: 6,
    question: '如何找到我喜欢的类型的韩漫？',
    answer: '您可以通过顶部的分类导航浏览不同题材的漫画，包括恋爱、奇幻、动作、校园、悬疑、剧情等多个分类。也可以使用搜索功能直接查找您感兴趣的作品名称。',
  },
];

export const stats = [
  { id: 1, value: '10,000+', label: '漫画作品' },
  { id: 2, value: '500万+', label: '月活跃读者' },
  { id: 3, value: '6+', label: '分类题材' },
  { id: 4, value: '24h', label: '全天候更新' },
];